var map = {
	"./angpao.webp": 2305,
	"./bonus.webp": 2306,
	"./gpi-rebate-m.webp": 2307,
	"./gpi-rebate.webp": 2308,
	"./hublot-watch-2018.webp": 2309,
	"./hublot-watch-2022.webp": 2310,
	"./iphone-13-pro-max.webp": 2311,
	"./iphone-14-pro-max.webp": 2312,
	"./login-to-m.webp": 2313,
	"./login-to.webp": 2314,
	"./mb.webp": 2315,
	"./mg-rebate-m.webp": 2316,
	"./mg-rebate.webp": 2317,
	"./np.webp": 2318,
	"./pointer.webp": 2319,
	"./pp-rebate-m.webp": 2320,
	"./pp-rebate.webp": 2321,
	"./sadface.webp": 2322,
	"./wallet-m.webp": 2323,
	"./wallet.webp": 2324,
	"./wheel-b.webp": 2325,
	"./wheel-btn.webp": 2326,
	"./wheel-indon-b.webp": 2327,
	"./wheel-indon.webp": 2328,
	"./wheel.webp": 2329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 923;